/// Port of mobile/lib/ui/flash_text.dart plus its textShadows helper.
///
/// Flutter drives a repeating reversed AnimationController; a CSS
/// alternating animation is the same curve at zero JavaScript cost.

import type { CSSProperties, ReactNode } from 'react';

export interface FlashTextProps {
  children: ReactNode;
  durationMs?: number;
  className?: string;
}

export function FlashText({ children, durationMs = 800, className = '' }: FlashTextProps) {
  return (
    <span
      className={className}
      style={{ animation: `dinodash-flash ${durationMs}ms ease-in-out infinite alternate` }}
    >
      {children}
    </span>
  );
}

/// Four offset copies of the glyph, matching Flutter's textShadows.
export function textShadow(color: string, size: number): CSSProperties['textShadow'] {
  return [
    `${-size}px ${-size}px 0 ${color}`,
    `${size}px ${-size}px 0 ${color}`,
    `${-size}px ${size}px 0 ${color}`,
    `${size}px ${size}px 0 ${color}`,
  ].join(', ');
}
